module.exports = __webpack_public_path__ + "static/media/mastercard.502fed74.svg";